import { MATCH_POSTAL_CODE } from '@/features/search-radiologist/utils/postal-codes-utils';
import { axios } from '@/plugins/axios';
import { GeoApiCity } from '@/types/geo-api-city';

/**
 * Classe de service pour les villes
 */
export class CityService {

    /**
     * Récupère la liste des villes suivant la recherche faite
     *
     * @param search la recherche
     * @returns la liste formatée des villes
     */
    static async getCityList(search: string): Promise<GeoApiCity[]> {
        const url = MATCH_POSTAL_CODE.test(search) ? `code/${search}` : `name/${search}`;

        const response = await axios.get<GeoApiCity[]>(`cities/${url}`);

        return response.data;
    }
}
